import React from 'react'
import { Link } from 'react-router-dom'

export default function Workout() {
  return (
   <div className="outerWorkout">
  <div className="workout">
    <h1 style={{color:"white"}}>⚡ Ready to Launch Your Tool or Product?</h1>
    <p style={{color:"white"}}>We don't do "maybe." We do scalable, secure, and successful — every time.</p>
    <p style={{color:"white", marginBottom: "30px"}}>Let's turn your idea into working software — FAST.</p>
    <Link to={'/write-for-us-saas'} style={{
      background: "linear-gradient(135deg, var(--accent-gold) 0%, var(--accent-gold-dark) 100%)",
      color: "var(--primary-dark)",
      padding: "15px 30px",
      borderRadius: "50px",
      fontWeight: "600",
      textDecoration: "none",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(255, 215, 0, 0.3)"
    }}>
      Book a Free Strategy Call
    </Link>
  </div>
</div>
  )
}
